import { Box } from '@material-ui/core';

import { Font } from './Font';

interface SectionTitleProps {
  overline: string | JSX.Element;
  title: string | JSX.Element;
}

export const SectionTitle = ({ overline, title }: SectionTitleProps) => {
  return (
    <Box display={'flex'} flexDirection={'column'} textAlign={'start'}>
      <Font variant={'overline'} color={'textSecondary'} className={'overflow-text-ellipsis'}>
        {overline}
      </Font>
      <Font variant={'body2'} color={'title'} className={'overflow-text-ellipsis'} style={{ maxWidth: 200 }}>
        <strong>{title}</strong>
      </Font>
    </Box>
  );
};
